import React from 'react';
import Button from '../../../atoms/Button/Button';
import Tooltip from '../../../atoms/Tooltip/Tooltip';

type ClearDateButtonProps = {
  isDisabled?: boolean;
  /** Motivo, ya traducido, por el que no se puede borrar la fecha. Con él el botón queda bloqueado y lo explica. */
  lockedTooltip?: string;
  onClick: () => void;
  text: string;
};

/**
 * «Borrar fecha» del pie de los diálogos de fecha (TAN-10806).
 *
 * Con `lockedTooltip` el botón usa `aria-disabled` en vez de `disabled`: un botón deshabilitado no recibe foco
 * ni eventos de ratón, así que el tooltip no llegaría por teclado. Así el lector lo anuncia como no disponible
 * y el motivo va en su descripción. Se descartó envolverlo en un span enfocable: Sonar lo marca (S6845).
 * El aspecto bloqueado lo pone `.clear-date-button--locked` (`_clear-date-button.scss`), porque el `Button`
 * del DS solo pinta el deshabilitado con `:disabled`.
 */
function ClearDateButton({ isDisabled = false, lockedTooltip, onClick, text }: ClearDateButtonProps): JSX.Element {
  if (!lockedTooltip) {
    return <Button isDisabled={isDisabled} onClick={onClick} size="sm" text={text} variant="secondary-ghost" />;
  }

  return (
    <Tooltip title={lockedTooltip}>
      <Button aria-disabled className="clear-date-button--locked" size="sm" text={text} variant="secondary-ghost" />
    </Tooltip>
  );
}

export default ClearDateButton;
